// https://lincolndealerdemo.cms.us-west-2.web-np.dealer.com/cpov.htm
export default {
	events: {
		widgetUserEvent: [
			{
				// hero "Search inventory" ws-content-cta button
				logic: {
					action: 'clicked',
					widgetName: 'ws-content-cta',
					widgetId: 'content-cta1'
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'cpo overview:nmbgt:search inventory',
							onclickLinkName: 'cpo overview:nmbgt:content:action'
						}
					}
				})
			}
		],
		'ddc.link.generic': [
			{
				// owner benefits "Search inventory" link
				logic: ({ eventData }) =>
					eventData?.attributes?.class?.includes?.(
						'cpov-search-inventory'
					),
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'cpo overview:nmbgt:search inventory',
							onclickLinkName: 'cpo overview:nmbgt:content:action'
						}
					}
				})
			}
		]
	}
};
